import { FormGroup, FormBuilder } from "@angular/forms";

export class M_MEMBER_PRICE {
    no: number = 0;
    hQ_CD: string = '';
    stR_CD: string = '';

    membeR_LVL: string = '';
    membeR_LVL_NM: string = '';

    lvL_PRICE: number = 0;
    lvL_SAVE_POINT: number = 0;
    lvL_USE_PERIOD: string = '0';
    lvL_USE_PERIOD_NM: string = '';

    remark: string | null = null;
    usE_YN: string = 'Y';

    inserT_DT: string | null = null;
    inserT_USER: string | null = null;
    updatE_DT: string | null = null;
    updatE_USER: string | null = null;
    newFG: boolean = false;

    constructor(init?: Partial<M_MEMBER_PRICE>) {
        Object.assign(this, init);
    }

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];

            obj[key] = value ?? null;
        });

        return obj;
    }

    fromJSON(json: any): M_MEMBER_PRICE {
        return new M_MEMBER_PRICE(json);
    }

    getAll(res: any[]): M_MEMBER_PRICE[] {
        return (res ?? []).map(e => new M_MEMBER_PRICE(e));
    }

    createForm(fb: FormBuilder): FormGroup {
        return fb.group({
            hQ_CD: [''],
            stR_CD: [''],
            membeR_LVL: [''],
            membeR_LVL_NM: [''],
            lvL_PRICE: [0],
            lvL_SAVE_POINT: [0],
            lvL_USE_PERIOD: ['0'],
            remark: [null],
            usE_YN: ['Y']
        });
    }

    formatDateTime(dateString: string): string {
        const date = new Date(dateString);

        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${y}${m}${d}${hh}${mm}${ss}`;
    }

    parseISODate(value: string): Date | null {
        if (!value) return null;
        return new Date(value);
    }
}